import { useMemo } from 'react';
import { fr, TranslationKey } from '../locales/fr';
import { DEFAULT_LANGUAGE } from '../config/i18n';

// Translation function type
type TranslateFunction = (key: string, params?: Record<string, string | number>) => string;

// Get nested value from object by path
const getNestedValue = (obj: any, path: string): string => {
  const keys = path.split('.');
  let value = obj;
  
  for (const key of keys) {
    if (value && typeof value === 'object' && key in value) {
      value = value[key];
    } else {
      return path; // Return key if not found
    }
  }
  
  return typeof value === 'string' ? value : path;
};

// Replace placeholders in string (e.g., {{name}})
const replacePlaceholders = (text: string, params?: Record<string, string | number>): string => {
  if (!params) return text;
  
  return text.replace(/\{\{(\w+)\}\}/g, (match, key) => {
    return params[key]?.toString() || match;
  });
};

/**
 * Translation hook
 * Currently only supports French. More languages can be added later.
 */
export const useTranslation = (): { t: TranslateFunction; language: string } => {
  const language = DEFAULT_LANGUAGE;
  
  const translations = useMemo(() => {
    // For now, only French is supported
    return fr;
  }, []);

  const t: TranslateFunction = (key: string, params?: Record<string, string | number>) => {
    const translation = getNestedValue(translations, key);
    return replacePlaceholders(translation, params);
  };

  return { t, language };
};

